import { UserSearchIcon } from "lucide-react";
import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Dialog, DialogClose, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle, DialogTrigger } from "@/components/ui/dialog";
import { Field, FieldLabel } from "@/components/ui/field";
import { IntakeLookupControl } from "./intake-lookup";
import { useIntakeMessages } from "./intake-messages";
import type { useTicketIntake } from "./use-ticket-intake";

export function TicketIntakeCustomerLookupDialog({ form, searchLabel }: { form: ReturnType<typeof useTicketIntake>; searchLabel: string }) {
  const m = useIntakeMessages();
  const [open, setOpen] = useState(false);
  const { session, busy, errors } = form;

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        <Button
          type="button"
          variant="outline"
          size="sm"
          disabled={busy || !session}
          aria-invalid={Boolean(errors.customerId)}
          aria-describedby={errors.customerId ? "intake-customer-error" : undefined}
        >
          <UserSearchIcon data-icon="inline-start" />
          {m.findSystemMember}
        </Button>
      </DialogTrigger>
      <DialogContent className="sm:max-w-xl">
        <DialogHeader>
          <DialogTitle>{m.findSystemMember}</DialogTitle>
          <DialogDescription>{m.customerLookupHint}</DialogDescription>
        </DialogHeader>
        <Field>
          <FieldLabel htmlFor="intake-customer-search">{m.member}</FieldLabel>
          <IntakeLookupControl
            capability="customers"
            inputId="intake-customer-search"
            searchLabel={searchLabel}
            disabled={busy || !session}
            lookup={form.lookup}
            scope={session?.id ?? ""}
            value={undefined}
            onChange={(option) => {
              if (!option) return;
              form.selectCustomer(option);
              setOpen(false);
            }}
          />
        </Field>
        <DialogFooter>
          <DialogClose asChild>
            <Button type="button" variant="outline">
              {m.cancel}
            </Button>
          </DialogClose>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
